import { type VolumeBasedPriceV1 } from '@redteclab/api/clients/bully'
import { type FC } from 'react'

import { useGetDiscountRanges } from 'views/components/organisms/VolumePricingModal/utils/volumePricingAccessor'
import VolumePricingModalNotification from 'views/components/organisms/VolumePricingModal/VolumePricingModalContent/VolumePricingModalNotification'
import VolumePricingModalTable from 'views/components/organisms/VolumePricingModal/VolumePricingModalContent/VolumePricingModalTable'
import withShopAndRuntimeConfig from 'views/enhancers/withShopAndRuntimeConfig'

import 'views/components/organisms/VolumePricingModal/VolumePricingModal.scss'

type VolumePricingModalContentProps = {
  volumeBasedPrices: VolumeBasedPriceV1[]
  volumeDiscount: number
  volumeQuantity: number
  volumeDiscountActivated: boolean
}

const VolumePricingModalContent: FC<VolumePricingModalContentProps> = ({
  volumeBasedPrices,
  volumeDiscount,
  volumeQuantity,
  volumeDiscountActivated,
}) => {
  const ranges = useGetDiscountRanges(volumeBasedPrices)
  return (
    <>
      <VolumePricingModalNotification
        volumeDiscount={volumeDiscount}
        volumeQuantity={volumeQuantity}
        volumeDiscountActivated={volumeDiscountActivated}
      />
      <VolumePricingModalTable ranges={ranges} />
    </>
  )
}

export default withShopAndRuntimeConfig(VolumePricingModalContent)
